import React, { createContext, useContext } from "react";
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import { getLanguage } from "./authorization/auth";

const languages = {
  en,
  hi
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {

  const text = (key) => {
    return languages[getLanguage()][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ text }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
